import _ from 'lodash';
import iso3166 from 'iso-3166-2';

export interface ISubdivision {
  code: string; // ISO 3166-2 code, e.g., 'AT-9'
  name: string; // Name, e.g., 'Wien'
  type: string; // Type, e.g., 'Federal länder', 'Canton'
}

/**
 * Get all subdivisions (states/provinces/cantons) for a given country code.
 * Returns sorted list with name and ISO code.
 */
export const getSubdivisionsForCountry = (countryCode: string): ISubdivision[] => {
  if (!countryCode) return [];

  const countryData = iso3166.country(countryCode.toUpperCase());
  if (!countryData || !countryData.sub) return [];

  const subdivisions = Object.entries(countryData.sub).map(([code, data]) => ({
    code,
    name: data.name,
    type: data.type,
  }));

  return _.sortBy(subdivisions, s => s.name);
};

/**
 * Get the name of a subdivision from its ISO 3166-2 code.
 * Returns the code itself if not found.
 */
export const getSubdivisionName = (isoCode: string | null | undefined): string => {
  if (!isoCode) return '';

  const subdivision = iso3166.subdivision(isoCode);
  if (!subdivision) return isoCode;

  return subdivision.name;
};

/**
 * Check if a country has subdivisions.
 */
export const countryHasSubdivisions = (countryCode: string): boolean => {
  if (!countryCode) return false;

  const countryData = iso3166.country(countryCode.toUpperCase());
  return !!(countryData && countryData.sub && Object.keys(countryData.sub).length > 0);
};
